export default __webpack_public_path__ + "static/media/sudance.6603214d.png";